import { V2_PROGRESS_BAR_ITEMS } from './progress-bar-items.config';

export const config = {
  v2: {
    PROGRESS_BAR_ITEMS: V2_PROGRESS_BAR_ITEMS,

    PostcodeSearchForm: {
      subtitle: 'Use the postcode finder below to enter the address where you would like our Home Design Service to help.',
      additionalFormDescription: (<p>Your virtual appointment will be with a Stylist nearest to the property.</p>),
      AddressDropdown: {
        buildDefaultOptionLabel: addressCount => `Please select the property address from the ${addressCount} found:`,
        addressFormLinkLabel: 'I can\'t see the property address in the list',
      },
    },
    Calendar: {
      timeSlotsList: undefined,
      eligibleSlotsFilter: undefined,
      formatTimeSlots: undefined,

      calendarTimeSlotsIntro: undefined,
      timeSlotSectionTitle: undefined,
    },
    subtitleComponent: ({ classNameForSubtitleWithLink }) => (
      <div className={classNameForSubtitleWithLink}>
        <p>Our appointments are carried out online so you can receive expert advice anywhere at a time that works for you.</p>
      </div>
    ),
    AboutYouForm: {
      formatTimeSlot: undefined,
    },
    ReviewForm: {
      formatTimeSlot: undefined,
      MainDetails: {
        addressTitle: 'Property address',
      },
    },
    BookingReview: {
      BookingDate: {
        formatTimeSlot: undefined,
      },
      YourAddress: {
        title: 'Property address',
      },
      icsEvent: {
        isVirtualAppointment: true,
      },
    },
  },
};
